import React from 'react';
import { FootprintsIcon, PersonStandingIcon, HandIcon, WavesIcon } from 'lucide-react';
import { mobilityAreas } from '../../data/presellContent';
const icons = {
  knees: FootprintsIcon,
  hips: PersonStandingIcon,
  hands: HandIcon,
  mobility: WavesIcon
} as const;
export function EverydayMobility() {
  return <section id="mobility" className="w-full bg-[#F7F9F8]" data-id="element-13" data-mp="u2dmwc0513x">
      <div className="max-w-6xl mx-auto px-5 md:px-8 py-14 md:py-20" data-id="element-14" data-mp="3sywc2feslm2u">
        <h2 className="text-2xl md:text-4xl font-bold text-[#22322C] leading-snug text-center max-w-3xl mx-auto" data-id="element-15" data-mp="3swtf1bf82som">
          When Joint Lubrication Starts To Decline, Everyday Movement Can Feel
          Different
        </h2>

        <ul className="mt-10 md:mt-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5" data-id="element-16" data-mp="3e1nbqw7ih7yz">
          {mobilityAreas.map(({
          id,
          area,
          description
        }) => {
          const Icon = icons[id];
          return <li key={id} className="bg-white rounded-2xl border border-[#E5E9E7] p-6 flex flex-col" data-id="element-17" data-mp="1c9r0lnp9a04q">
                <span className="w-11 h-11 rounded-full bg-[#EAF1EE] flex items-center justify-center" data-id="element-18" data-mp="2yrcidptyn89d">
                  <Icon className="w-5 h-5 text-[#3F8C86]" aria-hidden="true" data-id="element-19" data-mp="33pnqnw4lxaph" />
                </span>
                <h3 className="mt-5 text-lg font-semibold text-[#22322C]" data-id="element-20" data-mp="2tulyerf1bsio">
                  {area}
                </h3>
                <p className="mt-2 text-[#5A6D60] leading-relaxed" data-id="element-21" data-mp="3hjndgxidi1wx">
                  {description}
                </p>
              </li>;
        })}
        </ul>
      </div>
    </section>;
}